import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import debounce from 'lodash/debounce';

import { useRecoilValue } from 'recoil';
import currentFormAtom from '../../../../../../Atoms/currentForm';

import { getOptionsAsync } from '../../../../../../Utils/engine/triggerApi';
import safelyParseJSON from '../../../../../../Utils/safelyParseJSON';
import {
  IterationContext,
  getFieldDynamicDataState,
  withResolvedParams,
} from '../../../../../../Utils/engine/iteration';

const MultipleAutocomplete = ({
  schema,
  required,
  formData,
  onChange,
  errorSchema,
  dynamicLoading,
  formContext,
}) => {
  const currentForm = useRecoilValue(currentFormAtom);
  const iterationIndexes = useContext(IterationContext);
  // Options chargées par l'extension dynamicData (propres à l'itération courante)
  const dynamicState = getFieldDynamicDataState(schema, iterationIndexes);

  // Index gardés dans une ref : la recherche débouncée est créée une seule fois
  const iterationIndexesRef = useRef(iterationIndexes);
  iterationIndexesRef.current = iterationIndexes;

  const [data, setData] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentValue, setCurrentvalue] = useState(
    safelyParseJSON(formData) ?? []
  );
  const [options, setOptions] = useState([]);

  const onChangeInput = (e, newInputValue) => {
    setData(newInputValue);
  };

  useEffect(() => {
    if (dynamicState['@paramsAtFetch'] && dynamicState['@fetched']) {
      setOptions(dynamicState['@fetched']);
    }
  }, [currentForm.dynamicData.updatedTimestamp]);

  // const [inputValue, setInputValue] = React.useState('');
  const getOptionsDelayed = useCallback(
    debounce((text, callback) => {
      setOptions([]);
      // Paramètres "@value<chemin>" résolus depuis le formData complet et
      // l'itération courante (ex : le thème de la même démarche)
      getOptionsAsync(
        withResolvedParams(
          schema['@dynamicData'],
          formContext?.getFormData?.(),
          iterationIndexesRef.current
        ),
        text,
        currentValue
      ).then(callback);
    }, 500),
    []
  );

  useEffect(() => {
    setLoading(true);
    getOptionsDelayed(`${data}`, (filteredOptions) => {
      setOptions(filteredOptions);
      setLoading(false);
    });
  }, [data, getOptionsDelayed]);

  return (
    <Autocomplete
      disableCloseOnSelect
      multiple
      // disable filtering on client side
      filterOptions={(x) => x}
      getOptionLabel={(option) => option.label || option}
      getOptionSelected={(option) => option.id || option}
      loading={options.length === 0}
      loadingText={dynamicLoading(
        schema['@dynamicData'],
        data,
        options,
        loading
      )}
      options={options}
      renderInput={(params) => (
        <TextField {...params} label={schema.title} required={required} />
      )}
      onChange={(_event, newValue) => {
        // console.log(
        //   'onChange',
        //   newValue.map((element) => element.id)
        // );
        setCurrentvalue(newValue.map((element) => `${element.id}`));
        onChange(
          newValue.map((element) => `${element.id}`),
          errorSchema,
          2
        );
      }}
      onInputChange={(e, newInputValue) => onChangeInput(e, newInputValue)}
    />
  );
};

MultipleAutocomplete.propTypes = {
  schema: PropTypes.shape({
    title: PropTypes.string.isRequired,
    '@dynamicData': PropTypes.object.isRequired,
    description: PropTypes.string,
  }),
  required: PropTypes.bool,
  formData: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  errorSchema: PropTypes.any,
  dynamicLoading: PropTypes.func,
  formContext: PropTypes.shape({
    getFormData: PropTypes.func,
  }),
};

export default MultipleAutocomplete;
